module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2xrK8"))).then(() => parcelRequire('3a9aZ'));